(function () {
  // Section Rendering API / theme editor re-renders can re-run this script.
  if (window.requestACallAnalyticsBound) return;
  window.requestACallAnalyticsBound = true;

  const BUTTON_SELECTOR = '.product-request-a-call__button';

  function trackRequestACall(button) {
    const payload = {
      position: button.dataset.analyticsPosition || 'product_page',
      product_title: button.dataset.productTitle || '',
      button_text: button.textContent.trim()
    };

    Shopify.analytics.publish('request_a_call_clicked', payload);

    // TODO: remove once verified in the storefront.
    console.log('request_a_call_clicked', payload);
  }

  document.addEventListener('click', function (event) {
    if (!window.Shopify?.analytics?.publish) return;

    const button = event.target?.closest?.(BUTTON_SELECTOR);

    if (button) trackRequestACall(button);
  });
})();
